import React from 'react';
import { Link } from 'react-router-dom';
import FeatherIcon from './FeatherIcon';

const Partners: React.FC = () => {
  return (
    <section id="partners" className="py-20">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-4 text-gray-800">Our Partners</h2>
          <p className="text-xl max-w-3xl mx-auto text-gray-700">
            We collaborate with veterinary hospitals and community organizations to maximize our impact.
          </p>
        </div>

        <div className="max-w-2xl mx-auto mb-16">
          <div className="card p-8 text-center border-l-4 border-primary">
            <div className="w-16 h-16 bg-primary bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-6">
              <FeatherIcon name="plus-circle" className="text-primary" />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-800">Become a Clinic or Distributor Partner</h3>
            <p className="mb-6 text-gray-700">
              We are looking for veterinary clinics and community organizations to partner with us in providing essential pet care through our voucher program. Join us in creating a pawsitive future for underserved animals.
            </p>
            <Link to="/signup" className="btn-primary inline-block px-8 py-3 rounded-full font-medium">
              Join Our Partnership Program
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;